import React, { useState, useEffect } from "react";
import { Box } from "@material-ui/core";
import { FormActionDrawer, IntroText, CheckboxList } from "../../../components";
import { useHeader } from "../../../contexts";
import {
  formatApiValuesFromCheckboxList,
  formatCheckboxListFromApiValues
} from "../../../utils";
import { useTranslation } from "react-i18next";

const OptionsData = [
  {
    value: "symptom_fever",
    label_translation_key: "schedule.symptoms.options.symptom_fever"
  },
  {
    value: "symptom_cough",
    label_translation_key: "schedule.symptoms.options.symptom_cough"
  },
  {
    value: "symptom_short_breath",
    label_translation_key: "schedule.symptoms.options.symptom_short_breath"
  },
  {
    value: "symptom_fatigue",
    label_translation_key: "schedule.symptoms.options.symptom_fatigue"
  },
  {
    value: "symptom_muscle_body_aches",
    label_translation_key: "schedule.symptoms.options.symptom_muscle_body_aches"
  },
  {
    value: "symptom_headache",
    label_translation_key: "schedule.symptoms.options.symptom_headache"
  },
  {
    value: "symptom_lack_of_smell",
    label_translation_key: "schedule.symptoms.options.symptom_lack_of_smell"
  },
  {
    value: "symptom_sore_throat",
    label_translation_key: "schedule.symptoms.options.symptom_sore_throat"
  },
  {
    value: "symptom_congestion_runny_nose",
    label_translation_key:
      "schedule.symptoms.options.symptom_congestion_runny_nose"
  },
  {
    value: "symptom_nausea_vomitting",
    label_translation_key: "schedule.symptoms.options.symptom_nausea_vomitting"
  },
  {
    value: "symptom_diarrhea",
    label_translation_key: "schedule.symptoms.options.symptom_diarrhea"
  }
];

const ScheduleSymptoms = ({
  setDrawerClearance,
  updateScheduleData,
  scheduleData,
  isSubmitting
}) => {
  const { t } = useTranslation();
  const { setTitle } = useHeader();
  const [symptoms, setSymptoms] = useState();

  useEffect(() => {
    setTitle(t("schedule.symptoms.title"));
  }, []);

  const handleChange = values => {
    setSymptoms(values);
  };

  const handleNext = () => {
    updateScheduleData({
      symptoms: formatApiValuesFromCheckboxList(OptionsData, symptoms)
    });
  };

  return (
    <Box data-cy="schedule-screen-symptoms">
      <IntroText>{t("schedule.symptoms.intro_text")}</IntroText>
      {OptionsData.length > 0 && (
        <CheckboxList
          allowMultiple
          options={OptionsData}
          onChange={handleChange}
          initialValues={formatCheckboxListFromApiValues(scheduleData.symptoms)}
        />
      )}
      <FormActionDrawer
        setDrawerClearance={setDrawerClearance}
        handleNext={e => handleNext()}
        loading={isSubmitting}
      />
    </Box>
  );
};

export { ScheduleSymptoms };
